// extracted by mini-css-extract-plugin
module.exports = {"subMenu":"_1X2IK","container":"_3zFbL","bigDropdownWrapper":"fXImJ","background":"_1jO67","fadeIn":"_3wC6Z","expand":"_15xaa","mobileSeparator":"_24pdJ"};